export default __webpack_public_path__ + "static/media/batida.8afc3148.jpg";